import Vue from 'vue'
import request from '@/helpers/request'
import store from '@/store'

export default {
  LOAD_SETTINGS: async ({ commit, state }, params) => {
    let url = Vue.config.modules.crm.api.employer_settings.get.replace('$employer_id', params.employerId)
    await request(
      'GET',
      `${Vue.config.server}/${url}`,
      {
        params: {
          keys: params.keys,
          defaultValue: params.defaultHeaders,
        },
        disableNotifications: true,
      },
      true,
    ).then(
      response => {
        _.each(response.data.data, item => {
          store.commit('employerSettings/setSetting', {
            key: item.key,
            data: item.value,
          })
        })
      },
      () => {
        _.each(params.keys, item => {
          store.commit('employerSettings/setSetting', {
            key: item,
            data: params.defaultHeaders,
          })
        })
      },
    )
  },
  SAVE_SETTINGS: ({ commit, state }, params) => {
    let url = Vue.config.modules.crm.api.employer_settings.post.replace('$employer_id', params.employerId)
    request(
      'POST',
      `${Vue.config.server}/${url}`,
      {
        values: params.values,
      },
      true,
    ).then(
      response => {},
      response => {},
    )
  },
}
